export default "__VITE_ASSET__2jfgquNz__"